import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from "../../../environments/environment";
import {Product} from "../model/view/Product";
import {Observable} from "rxjs";
import toUrl from "../higherOrderFunction/toUrl";
import {Poses} from "../model/PosModel";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ProductDetailsService {
  private apiURL = environment.links.productDetails.apiURL;
  private availabilityURL = environment.links.productDetails.availabilityURL;
  private addToCartURL = environment.links.productDetails.addToCartURL;
  private addInsuranceURL = environment.links.productDetails.addInsuranceURL;
  private insuranceVariantName = window['ACC']['productDetailsPage']?.insuranceVariantName;
  private httpOptions = {
    headers: new HttpHeaders({
      "X-CSRF-TOKEN": window['ACC']['config']['CSRFToken']
    })
  };

  constructor(private http: HttpClient) { }

  getProduct(code: string): Observable<Product> {
    return this.http.get<Product>(`${this.apiURL}/${code}`, this.httpOptions);
  }

  getAvailability({code, town}) {
    const url = toUrl(`${this.apiURL}/${code}${this.availabilityURL}`,[], {town});
    return this.http.get<Poses>(url, this.httpOptions).pipe(
      map(response => response.poses)
    );
  }

  addToCart({productCodePost, qty, skipCheckingStock}) {
    const url = toUrl(`${this.addToCartURL}`,[], {productCodePost, qty, skipCheckingStock});
    return this.http.post(url,'', this.httpOptions);
  }

  addInsurance(productCode) {
    const url = toUrl(`${this.addInsuranceURL}`, [], {productCode, insuranceCode: this.insuranceVariantName});
    return this.http.post(url, '', this.httpOptions);
  }
}
